import * as React from 'react';
import { connect } from 'react-redux';
import { ConfigurationModel } from 'franke-trough-dependencies';
import { Link } from 'react-router-dom';
import { GlobalPrivateState, dynamicTitles, dynamicTitlesKey } from 'src/api';
import { CompletionStatus } from './CompletionStatus';
import { FormattedMessage } from 'react-intl';
import { Icon } from '../../../Images';
import MESSAGES from './ListItemDetail.messages';
import { isConfigurationEditable } from 'src/redux/utils.redux';

export interface ConfigurationListItemDetailProps {
  configuration: ConfigurationModel;
  dispatch: any;
  language: GlobalPrivateState['localize']['language'];
  queryState: GlobalPrivateState['queryState'];
  userData: GlobalPrivateState['userData'];
}

export class ConfigurationListItemDetailPartial extends React.Component<ConfigurationListItemDetailProps> {
  constructor(props: ConfigurationListItemDetailProps) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  public render() {
    const { configuration, language, userData } = this.props;
    const configurationDate = new Date(configuration.created_at).toLocaleDateString(language.selected, {timeZone: 'UTC'});
    const configurationTroughsQty = configuration.selectedTrough && configuration.selectedTrough.qty;
    const configurationBasinDimensionWidth = configuration.washBasinDimension && configuration.washBasinDimension.plateWidth;
    const configurationBasinDimensionDepth = configuration.washBasinDimension && configuration.washBasinDimension.plateDepth;

    return (
      <div className="configuration-list-settings">
        <div className="header">
          {configuration.userData ? (
            <>
              {configuration.userData.firstName.substr(0, 2)}
              {configuration.userData.lastName.substr(0, 2)}
            </>
          ) : (
            <>
              {userData && userData.result && userData.result.firstName.substr(0, 2)}
              {userData && userData.result && userData.result.lastName.substr(0, 2)}
            </>
          )}
        </div>
        <div className="main">
          <div className="body">
            <Link 
              onClick={() => this.handleClick()}
              to={!configuration.country ? `/configuration/${configuration.id}/project` : `/configuration/${configuration.id}/trough`}
              title={configuration.name}
            >
              <h4>{configuration.name}</h4>
            </Link>
            {configuration.projects && (
              <h6 className="project-name">
                {configuration.projects.name}, {configuration.projects.city}
              </h6>
            )}
          </div>

          <div className="row">
            <div className="col-sm12 col-6 list-item__detail">
              <h6><FormattedMessage {...MESSAGES.listItemDetailBasin} />:</h6>
              {configurationBasinDimensionWidth || '0'}x{configurationBasinDimensionDepth || '0'} mm
            </div>
            <div className="col-sm12 col-6 list-item__detail">
              <h6><FormattedMessage {...MESSAGES.listItemDetailNumber} />:</h6>
              {configurationTroughsQty}
            </div>
          </div>
          
          <div className="footer">
            {configuration && (
              <div className="order-offer">
                <CompletionStatus type={configuration.completionStatus || 'draft'} />: {configuration.sapNumber}
              </div>
            )}
            <div className="timestamp">
              {configurationDate}
            </div>
          </div>
        </div>
      </div>
    );
  }
  
  private handleClick() {
    this.props.dispatch(dynamicTitles.add({
      key: dynamicTitlesKey.dashboard,
      value: this.props.configuration.name,
    }));
  }
}

export const ConfigurationListItemDetail = connect((state: GlobalPrivateState) => ({
  language: state.localize.language,
  queryState: state.queryState,
  userData: state.userData,
}))(ConfigurationListItemDetailPartial);

export default ConfigurationListItemDetail;
